class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
        window.addEventListener('resize', this.updateHeightContent.bind(this))
        this.productId = '';
        this.quantity = 1;


        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;

                        this.initSwiper()
                        this.querySelectorAll(".custom-button").forEach((button) => {
                            button.addEventListener('click', this.addToCart.bind(this))
                        })
                        var api = new Yotpo.API(yotpo);
                        api.refreshWidgets();


                    }
                }).then(test => {
                    this.updateHeightContent()
                })
                .catch(e => {
                    console.error(e);
                });
        }

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);



    }


    init() {
        console.log('cocuou 3')
    }


    updateHeightContent() {

        const maxHeightTitle = [];
        this.querySelectorAll('.detail-main-content__title').forEach((item) => {
            item.style.height = 'auto'
            maxHeightTitle.push(item.offsetHeight);
        })

        this.querySelectorAll('.detail-main-content__title').forEach((item) => {
            item.style.height = `calc(${Math.max(...maxHeightTitle)}px )`;
        })

        const maxHeightTags = [];
        this.querySelectorAll('.detail-main-content__tags ').forEach((item) => {
            item.style.height = 'auto'
            maxHeightTags.push(item.offsetHeight);
        })

        this.querySelectorAll('.detail-main-content__tags ').forEach((item) => {
            item.style.height = `calc(${Math.max(...maxHeightTags)}px )`;
        })

        const maxHeightBenef = [];
        this.querySelectorAll('.detail-main-content__types__container').forEach((item) => {
            item.style.height = 'auto'
            maxHeightBenef.push(item.offsetHeight);
        })

        this.querySelectorAll('.detail-main-content__types__container').forEach((item) => {
            item.style.height = `calc(${Math.max(...maxHeightBenef)}px )`;
        })


        const maxHeight = [];
        this.querySelectorAll('.product-card-v2__details').forEach((item) => {
            item.style.height = 'auto'
            maxHeight.push(item.offsetHeight);
        })

        this.querySelectorAll('.product-card-v2__details').forEach((item) => {
            item.style.height = `calc(${Math.max(...maxHeight)}px )`;
        })

    }

    addToCart(e) {

        this.productId = e.currentTarget.parentNode.querySelector('.input-quantity').value;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.productId.toString(),
                quantity: 1
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    bubbles: true,
                    detail: {
                        variant: this.productId,
                        quantity: 1
                    }
                }));
            });
    }

    initSwiper() {


        const swiper = new Swiper(this.querySelector('.recommanded-swiper'), {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            a11y: false,
            speed: 400,
            threshold: 15,
            // If we need pagination
            pagination: {
                el: this.querySelector('.recommanded-swiper-pagination'),
            },
            breakpoints: {
                381: {
                    cssMode: false,
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                821: {
                    cssMode: false,
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                1230: {
                    slidesPerView: 4,
                    spaceBetween: 60
                }
            },
            navigation: {
                nextEl: this.querySelector('.swiper-recommended-next'),
                prevEl: this.querySelector('.swiper-recommended-prev'),
            },
        });
        this.swiper = swiper;
    }
}

customElements.define('product-recommendations', ProductRecommendations);
